import { DealStatus } from "./IDeal";
import { LeadOwnershipType, LeadStatus } from "./ILead";
import { LeaseCompPropertyType } from "./ILeaseComp";
import { SaleCompPropertyType } from "./ISaleComp";

export default interface IFilterSettings {
    dealSettings: IDealFilterSettings;
    leadSettings: ILeadFilterSettings;
    leaseCompSettings: ILeaseCompFilterSettings;
    saleCompSettings: ISaleCompFilterSettings;
    tenantInMarketSettings: ITenantInMarketFilterSettings;
    companySettings: ICompanyFilterSettings;
}

export interface IDealFilterSettings {
    minValue: number | null;
    maxValue: number | null;
    minBuildingSize: number | null;
    maxBuildingSize: number | null;
    minLandSize: number | null;
    maxLandSize: number | null;
    pipedrivePersonName: string;
    keyword: string;
    statuses: DealStatus[];
    dealStageIds: number[];
    labelIds: number[];
    hideSold: boolean;
    hideNonFund: boolean;
    minDateModified: Date | null;
    maxDateModified: Date | null;
}

export interface ILeadFilterSettings {
    minLotCoverage: number | null;
    maxLotCoverage: number | null;
    minBuildingSize: number | null;
    maxBuildingSize: number | null;
    minLandSize: number | null;
    maxLandSize: number | null;
    minUsableArea: number | null;
    maxUsableArea: number | null;
    statuses: LeadStatus[];
    showWithReminder: boolean;
    showWithoutReminder: boolean;
    labelIds: number[];
    locationGrades: string[];
    propertyGrades: string[];
    ownershipTypes: LeadOwnershipType[];
    pipedriveCompanyName: string;
    keyword: string;
    minDateModified: Date | null;
    maxDateModified: Date | null;
}

export interface ILeaseCompFilterSettings {
    minTenantLandSize: number | null;
    maxTenantLandSize: number | null;
    minBuildingSize: number | null;
    maxBuildingSize: number | null;
    minAnnualRent: number | null;
    maxAnnualRent: number | null;
    minLeaseExpiration: Date | null;
    maxLeaseExpiration: Date | null;
    minDateModified: Date | null;
    maxDateModified: Date | null;
    propertyTypes: LeaseCompPropertyType[];
}

export interface ISaleCompFilterSettings {
    minUsableLandSize: number | null;
    maxUsableLandSize: number | null;
    minParcelSize: number | null;
    maxParcelSize: number | null;
    minBuildingSize: number | null;
    maxBuildingSize: number | null;
    minSalePrice: number | null;
    maxSalePrice: number | null;
    minSaleDate: Date | null;
    maxSaleDate: Date | null;
    minDateModified: Date | null;
    maxDateModified: Date | null;
    propertyTypes: SaleCompPropertyType[];
}

export interface ITenantInMarketFilterSettings {
    createdWithin: CreatedWithin;
    showInactive: boolean;
    showLostDeals: boolean;
}

export interface ICompanyFilterSettings {
    includeSaleComps: boolean;
    includeLeaseComps: boolean;
    hideDuplicateLocations: boolean;
    minLocationCount: CompanyMinLocationCount;
    hideNoLogoCompany: boolean; 
}

export enum CreatedWithin {
    Anytime = "Anytime",
    OneMonth = "OneMonth",
    ThreeMonth = "ThreeMonth",
    SixMonth = "SixMonth",
    TwelveMonth = "TwelveMonth",
}

export enum CompanyMinLocationCount {
    All = "All",
    Ten = "Ten",
    TwentyFive = "TwentyFive",
    Fifty = "Fifty",
    OneHundred = "OneHundred",
}